import { requestPayment } from 'Cloud/Application/Payment';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardActions } from 'reactApp/modules/creditCard/creditCard.module';
import { getFeatureUnionQuotaTariffsList, getQuotaLandingTariffsConfig } from 'reactApp/modules/features/features.selectors';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { updateSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.module';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { prepareTariffsList } from 'reactApp/sections/QuotaLanding/TariffsPlans/TariffsPlans.helpers';
import type { PreparedTariff } from 'reactApp/sections/QuotaLanding/TariffsPlans/types';
/**
 * Хук покупки рекомендованного тарифа "Единой квоты"
 * Используется в чистилке как тариф по умолчанию
 */
export const useBuyCleanerTariff = (): {
    tariffId?: string;
    tariffPrice?: number;
    tariffValue?: string;
    onBuy: () => void;
} => {
    const dispatch = useDispatch();
    const isUnionQuotaTariffsList = useSelector(getFeatureUnionQuotaTariffsList);
    const tariffs = useSelector(ProductsSelectors.getTariffs);
    const quotaLandingTariffsConfig = useSelector(getQuotaLandingTariffsConfig);

    const recomendedTariff: Partial<PreparedTariff> = useMemo(() => {
        if (!isUnionQuotaTariffsList) {
            return {};
        }

        const list = prepareTariffsList(tariffs, quotaLandingTariffsConfig);
        return list?.find((tariff) => tariff.isRecommended) || {};
    }, [tariffs, quotaLandingTariffsConfig, isUnionQuotaTariffsList]);

    const { monthTariffId, monthPrice, monthSpace } = recomendedTariff;
    const onBuy = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requestPayment({
            productId: monthTariffId,
            forceFastCheckout: true,
            onSuccess: () => {
                sendQuotaGa({ action: 'tariff', label: 'buy', tariff: monthTariffId, amount: monthPrice });
                dispatch(CardActions.updateCard({ isSilent: true }));
                dispatch(updateSubscriptionsRequest());
                snackbarController.showSnackbar({
                    type: SnackbarTypes.success,
                    text: 'Подписка успешно оформлена',
                    id: 'quotaCleanerTariffBuy',
                    closable: true,
                });
            },
        });
    }, [recomendedTariff]);

    return {
        tariffId: monthTariffId,
        tariffPrice: monthPrice,
        tariffValue: monthSpace?.value,
        onBuy,
    };
};
